import React from 'react';
import Constants from '../../data/Constants';
import PropTypes from 'prop-types';
import GenericInputSelect from '../common/GenericSearchBar/GenericInputSelect';

class DocumentTypeInput extends React.Component {
  handleChange = (documentType) => {
    this.props.handleInputChange({ documentType: documentType });
  };

  render() {
    return (
      <GenericInputSelect
        handleInputChange={this.handleChange}
        selectName={'documentTypeSearch'}
        selectOptions={Constants.documentTypes}
        selectPlaceholder={'Documento'}
        value={this.props.values?.documentType || ''}
      />
    );
  }
}

DocumentTypeInput.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  values: PropTypes.object
};

export default DocumentTypeInput;
